import React, { Fragment, useState, useEffect } from 'react'
import StepWizard from 'react-step-wizard'

import SelecionarAvaliacao from './SelecionarAvaliacao'
import Anamnese from '../../Avaliacao/Anamnese'
import DefinicaoTratamento from './DefinicaoTratamento'
import OrtodontiaService from '../../../services/ortodontia.service'
import { formatMoney } from '../../../utils/string.utils'

import PageLoading from '../../Common/PageLoading'
import ortodontiaService from '../../../services/ortodontia.service'
import pacienteService from '../../../services/paciente.service'
import AnamneseService from '../../../services/anamnese.service'
import Navigation from './Navigation'
import {
  obterExameRadiologicoPronto,
  obterIdAvaliacaoOrtodontia,
  isValidGuid,
  statusAvaliacaoOrtodontica,
} from '../../../constants/agendamento.constants'

export default function AvaliacaoOrtodontiaWizard(props) {
  const { pacienteId, agendamento = {}, anamneseFichaId, history, perguntasAnamnese } = props
  const pacienteIdResolvido = pacienteId || agendamento.pacienteId
  const INITIAL_FICHA = {
    statusAvaliacao: 0,
    agendamentoId: agendamento.id,
    pacienteId: pacienteIdResolvido,
    dependenteId: agendamento.dependenteId,
    anamneseFichaId: null,
    anamneseRespostas: [],
    anamnesePerguntas: [],
    aparelhoId: null,
  }
  const avaliacaoInicial =
    agendamento.avaliacaoOrtodontia && isValidGuid(agendamento.avaliacaoOrtodontia.id)
      ? agendamento.avaliacaoOrtodontia
      : INITIAL_FICHA
  const [fichaInicial, setFichaInicial] = useState(INITIAL_FICHA)
  const [isLoading, setIsLoading] = useState(true)
  const [wizardRef, setWizardRef] = useState(null)
  const [selectedAvaliacao, setSelectedAvaliacao] = useState(avaliacaoInicial)
  const [avaliacoesPaciente, setAvaliacoesPaciente] = useState([])
  const [paciente, setPaciente] = useState()
  const [selectedEncaminhamento, setSelectedEncaminhamento] = useState(null)
  const [selectedAparelho, setSelectedAparelho] = useState(null)
  const [aparelhoOptions, setAparelhoOptions] = useState([])
  const [isAparelhoLoading, setIsAparelhoLoading] = useState(true)
  const [passo, setPasso] = useState(1)
  const [pularParaPasso, setPularParaPasso] = useState(null)

  useEffect(() => {
    carregarTela()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (wizardRef && pularParaPasso) {
      if (typeof wizardRef.goToStep === 'function') {
        wizardRef.goToStep(pularParaPasso)
      } else if (pularParaPasso > 1 && typeof wizardRef.nextStep === 'function') {
        wizardRef.nextStep()
      }
      setPularParaPasso(null)
    }
  }, [wizardRef, pularParaPasso])

  useEffect(() => {
    if (perguntasAnamnese && perguntasAnamnese.length > 0) {
      const anamneseFicha =
        perguntasAnamnese.find((perguntas) => perguntas.id === anamneseFichaId) ||
        perguntasAnamnese.find((perguntas) => perguntas.anamneseFichaId === anamneseFichaId)
      if (anamneseFicha) {
        atualizarPerguntasAnamnese(anamneseFicha.anamnesePerguntas || anamneseFicha, anamneseFicha.id, anamneseFicha.nome)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [perguntasAnamnese])

  const carregarTela = async () => {
    try {
      const avaliacaoId = obterIdAvaliacaoOrtodontia(agendamento)
      const tarefas = [getAparelhos()]

      if (isValidGuid(pacienteIdResolvido)) {
        tarefas.push(getPaciente(pacienteIdResolvido))
      }
      if (isValidGuid(agendamento.id)) {
        tarefas.push(getAnamnese())
      }

      if (isValidGuid(avaliacaoId)) {
        tarefas.push(carregarAvaliacaoAtual(avaliacaoId))
      } else {
        tarefas.push(
          getAvaliacoesPaciente(pacienteIdResolvido).then((lista) => {
            if (!lista.length) setPularParaPasso(2)
          })
        )
      }

      await Promise.all(tarefas)
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  const carregarAvaliacaoAtual = async (id) => {
    try {
      const { data } = await ortodontiaService.getAvaliacaoById(id)
      if (!data || !isValidGuid(data.id)) return

      const deveIrParaRecepcao =
        data.statusAvaliacao === statusAvaliacaoOrtodontica.EXAME_SOLICITADO.value ||
        data.statusAvaliacao === statusAvaliacaoOrtodontica.TRATAMENTO_DEFINIDO.value ||
        data.statusAvaliacao === statusAvaliacaoOrtodontica.AGUARDANDO_ASSINATURA.value

      if (deveIrParaRecepcao) {
        history.replace('/ortodontia/avaliacao/recepcao')
        return
      }

      setSelectedAvaliacao((atual) => ({ ...atual, ...data }))
      setPularParaPasso(data.statusAvaliacao === statusAvaliacaoOrtodontica.EXAME_MARCADO.value ? 3 : 2)
    } catch (error) {
      console.error(error)
    }
  }

  const getAnamnese = async () => {
    try {
      const { data } = await AnamneseService.getRespostasByAgendamentoId(agendamento.id)
      if (data?.anamnesePerguntas) {
        onChangeFicha(data.anamnesePerguntas, data.id, data.nome)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const getAparelhos = async () => {
    try {
      const { data } = await OrtodontiaService.getAparelhosCadastrados()
      setAparelhoOptions(
        data.map((opt) => ({
          value: opt.id,
          label: `${opt.nome} - ${formatMoney(opt.valorVenda)}`,
        }))
      )
    } catch (e) {
      setAparelhoOptions([])
    }
    setIsAparelhoLoading(false)
  }

  const getAvaliacoesPaciente = async (pacienteIdAtual) => {
    try {
      if (isValidGuid(agendamento.dependenteId)) {
        const { data } = await ortodontiaService.getAvaliacoesDependente(agendamento.dependenteId)
        setAvaliacoesPaciente(data || [])
        return data || []
      }
      if (!isValidGuid(pacienteIdAtual)) return []
      const { data } = await ortodontiaService.getAvaliacoesPaciente(pacienteIdAtual)
      setAvaliacoesPaciente(data || [])
      return data || []
    } catch (error) {
      console.error(error)
      return []
    }
  }

  const getPaciente = async (id) => {
    if (!isValidGuid(id)) return
    try {
      const { data } = await pacienteService.getPacienteById(id)
      setPaciente(data)
    } catch (e) {}
  }

  const atualizarPerguntasAnamnese = (perguntas, fichaId, nome) => {
    if (!perguntas || !Array.isArray(perguntas)) return
    setSelectedAvaliacao((atual) => {
      const novaFicha = { ...atual }
      if (nome && !novaFicha.nome) {
        novaFicha.nome = nome
      }
      novaFicha.anamneseRespostas = novaFicha.anamneseRespostas?.length
        ? novaFicha.anamneseRespostas
        : new Array(perguntas.length)
      novaFicha.anamneseFichaId = fichaId || novaFicha.anamneseFichaId
      novaFicha.anamnesePerguntas = perguntas
      const avaliacao = { ...novaFicha, anamneseFicha: perguntas }
      setFichaInicial(avaliacao)
      return avaliacao
    })
  }

  const onChangeRespostaRadio = (index, { target }) => {
    let novasRespostas = [...(selectedAvaliacao.anamneseRespostas || [])]
    if (novasRespostas[index]) {
      novasRespostas[index].tipoResposta = target.value
    } else {
      novasRespostas[index] = {
        tipoResposta: target.value,
        texto: null,
        anamneseId: target.name,
      }
    }
    setSelectedAvaliacao({
      ...selectedAvaliacao,
      anamneseRespostas: novasRespostas,
    })
  }

  const onChangeRespostaTexto = (index, { target }) => {
    let novasRespostas = [...(selectedAvaliacao.anamneseRespostas || [])]
    if (novasRespostas[index]) {
      if (!target.value && novasRespostas[index].tipoResposta === null) {
        novasRespostas[index] = undefined
      } else {
        novasRespostas[index].texto = target.value
      }
    } else {
      novasRespostas[index] = {
        tipoResposta: null,
        texto: target.value,
        anamneseId: target.name,
      }
    }
    setSelectedAvaliacao({
      ...selectedAvaliacao,
      anamneseRespostas: novasRespostas,
    })
  }

  const onChangeFicha = (perguntas, fichaId, nome) => atualizarPerguntasAnamnese(perguntas, fichaId, nome)

  const handleSelectAvaliacao = async (avaliacao) => {
    if (!isValidGuid(avaliacao?.id)) return
    setIsLoading(true)
    try {
      const { data } = await ortodontiaService.getAvaliacaoById(avaliacao.id)
      setSelectedAvaliacao({
        ...selectedAvaliacao,
        ...data,
      })
      wizardRef.nextStep()
    } catch (error) {
      console.error(error)
    }
    setIsLoading(false)
  }

  const handleChangeAparelho = (aparelho) => {
    setSelectedAparelho(aparelho)
    if (aparelho) {
      setSelectedAvaliacao({ ...selectedAvaliacao, aparelhoId: aparelho.value })
    }
  }

  const renderLoading = () => <PageLoading />

  const onStepChange = (passoAtual) => {
    if (passoAtual.activeStep === 1) {
      setSelectedAvaliacao({
        ...fichaInicial,
        anamneseRespostas: new Array((perguntasAnamnese || []).length),
      })
      setSelectedEncaminhamento(null)
      setSelectedAparelho(null)
    }
    setPasso(passoAtual.activeStep)
  }

  return (
    <Fragment>
      <StepWizard isLazyMount onStepChange={onStepChange} instance={setWizardRef}>
        <SelecionarAvaliacao
          agendamento={agendamento}
          handleSelectAvaliacao={handleSelectAvaliacao}
          history={history}
          avaliacoes={avaliacoesPaciente}
          isLoading={isLoading}
        />
        <Anamnese
          {...props}
          avaliacaoPreenchida={isValidGuid(selectedAvaliacao.id)}
          respostas={selectedAvaliacao.anamneseRespostas || []}
          onChangeRadio={onChangeRespostaRadio}
          onChangeTexto={onChangeRespostaTexto}
          paciente={paciente}
          selectedFicha={selectedAvaliacao}
        />
        <DefinicaoTratamento
          selectedEncaminhamento={selectedEncaminhamento}
          setSelectedEncaminhamento={setSelectedEncaminhamento}
          selectedAparelho={selectedAparelho}
          setSelectedAparelho={handleChangeAparelho}
          aparelhoOptions={aparelhoOptions}
          isAparelhoLoading={isAparelhoLoading}
          wizardRef={wizardRef}
          history={history}
          agendamento={
            (selectedAvaliacao?.agendamentosRadiologia || []).slice(-1)[0]?.arquivos?.length
              ? selectedAvaliacao.agendamentosRadiologia[selectedAvaliacao.agendamentosRadiologia.length - 1]
              : obterExameRadiologicoPronto(avaliacoesPaciente, selectedAvaliacao?.id)
          }
        />
      </StepWizard>
      <Navigation
        selectedEncaminhamento={selectedEncaminhamento}
        avaliacoes={avaliacoesPaciente}
        selectedAvaliacao={selectedAvaliacao}
        {...props}
        passo={passo}
        wizard={wizardRef}
      />
      {isLoading && renderLoading()}
    </Fragment>
  )
}
